import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';
import { formatDate } from '@/utils/dateUtils';

interface UpcomingEvent {
  id: string;
  title: string;
  date: string;
  time: string;
  location: string;
  image: string;
  category: string;
}

interface UpcomingEventsListProps {
  events: UpcomingEvent[];
}

const UpcomingEventsList: React.FC<UpcomingEventsListProps> = ({ events }) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-subtle">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="ClockIcon" size={20} className="text-primary" />
        <h3 className="text-lg font-heading font-bold text-foreground">Upcoming Events</h3>
      </div>

      <div className="space-y-4">
        {events.map((event) => (
          <Link
            key={event.id}
            href={`/events/${event.id}`}
            className="flex space-x-4 p-4 rounded-lg hover:bg-muted transition-colors duration-200 cursor-pointer"
          >
            <div className="flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden">
              <AppImage
                src={event.image}
                alt={event.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 mb-1">
                <span className="px-2 py-0.5 rounded text-xs font-semibold bg-accent/10 text-accent">
                  {event.category}
                </span>
              </div>
              <h4 className="text-sm font-semibold text-foreground mb-2 line-clamp-1">
                {event.title}
              </h4>
              <div className="space-y-1">
                <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                  <Icon name="CalendarIcon" size={14} />
                  <span>{formatDate(event.date)}</span>
                </div>
                <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                  <Icon name="MapPinIcon" size={14} />
                  <span className="truncate">{event.location}</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default UpcomingEventsList;